// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_navigation.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for handling navigation between URLs.
// </summary>
// ***********************************************************************

window.navigation = window.navigation || {};

/**
 * Navigates to a specified URL, optionally opening it in a new window or tab.
 *
 * @function to
 * @memberof window.navigation
 * @param {string} url - The URL to navigate to.
 * @param {boolean} newWindow - If true, opens the URL in a new window or tab; otherwise, navigates in the current window.
 */
window.navigation.to = function (url, newWindow) {
    if (newWindow) {
        window.open(url, '_blank');
    } else {
        window.location.href = url;
    }
};